import ChapterButtonComponent from "components/ChapterButtonComponent";
import getChapterNumber from "selectors/chapter/getChapterNumber";
import NavigationWrapper from "utils/NavigationWrapper";
import { AnalyticsActions } from "utils/Analytics";
import {
  compose,
  setDisplayName,
  onlyUpdateForPropTypes,
  withHandlers,
} from "recompose";
import { connect } from "react-redux";
import find from "lodash/find";
import omit from "lodash/omit";

function getChapterData(story, id) {
  const chapterEntity = find(story.chapters, { id });
  return story.entities[chapterEntity.schema][chapterEntity.id];
}

const mapStateToProps = (state, ownProps) => {
  const result = {
    showChapterButtons: state.playerOptions.chapterNavigationButtons !== "hide",
    chapterNumber: getChapterNumber(state, ownProps),
    reduxState: state,
  };

  // Remove `orderFromChapterNumber` in `mergeProps`, the component doesn't need it.
  if (ownProps.orderFromChapterNumber) {
    result.style = {
      ...ownProps.style,
      order: (getChapterNumber(state, ownProps) - 1) * 10,
    };
  }

  return result;
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...omit(stateProps, "reduxState", "orderFromChapterNumber"),
  onClick: () => {
    if (ownProps.on) return; // do nothing if active
    const chapterId = ownProps.chapterId;
    const chapter = getChapterData(stateProps.reduxState.story, chapterId);
    const slug = chapter.slugs[0];

    NavigationWrapper.push(
      null,
      stateProps.reduxState.route.params.storySlug,
      slug,
      {
        destroyPlaybackStateForChapterId: chapterId,
      },
    );

    AnalyticsActions.chapterButton();
  },
});

export default compose(
  setDisplayName("ChapterButtonContainer"),
  connect(mapStateToProps, null, mergeProps),
  withHandlers({
    onClick: (props) => props.onClick,
  }),
  onlyUpdateForPropTypes,
)(ChapterButtonComponent);
